/**
 * Pivot Points adapter for the chart chassis.
 * Converts the null-padded arrays from calcPivotLevels into
 * LWC {time,value} format, keyed by level name.
 *
 * @param {Array<{time:number, open:number, high:number, low:number, close:number, volume:number}>} bars
 * @param {string} barSize  '1 day' | '30 mins' | '15 mins' | '5 mins' | etc.
 * @returns {{ pivot: Array<{time:number,value:number}>, r1: Array<{time:number,value:number}>, r2: Array<{time:number,value:number}>, r3: Array<{time:number,value:number}>, s1: Array<{time:number,value:number}>, s2: Array<{time:number,value:number}>, s3: Array<{time:number,value:number}> }}
 */
import { calcPivotLevels } from '../indicators.js'

const LEVEL_KEYS = ['pivot', 'r1', 'r2', 'r3', 's1', 's2', 's3']

export function computePivotLevels(bars, barSize) {
  if (!Array.isArray(bars) || bars.length === 0) {
    return Object.fromEntries(LEVEL_KEYS.map(k => [k, []]))
  }
  const raw = calcPivotLevels(bars, barSize)
  const result = {}
  for (const key of LEVEL_KEYS) {
    const arr = raw[key]
    const out = []
    for (let i = 0; i < bars.length; i++) {
      if (arr[i] != null && Number.isFinite(arr[i]) && Number.isFinite(bars[i].time)) {
        out.push({ time: bars[i].time, value: arr[i] })
      }
    }
    result[key] = out
  }
  return result
}
